import { DistanceType } from '../domain/project/ProjectUnits';
import { FuelTypes } from '../domain/vehicle/Vehicle';

const kmToSM = (km: any, distanceIn: any) => {
  if (distanceIn === `mi`) {
    return km * 0.621371;
  }
  return km;
};

const SMToKm = (sm: any, distanceIn: any) => {
  if (distanceIn === `mi`) {
    return sm / 0.621371;
  }
  return sm;
};

/*

Transforms a distance in *ProjectUnits - [Meters or Yards]* to meters.

*/
const SMToMeters = (value: number, ProjectUnits?: string) => {
  if (ProjectUnits === `mi`) {
    return value * 0.9144; // Yards to meters
  }
  return value;
};

/*

Transforms a distance in meters to *ProjectUnits - [Meters or Yards]*.

*/
const MetersToSM = (value: number, ProjectUnits?: string) => {
  if (ProjectUnits === `mi`) {
    return value * 1.09361; // Meters to yards
  }
  return value;
};

const consumptionByFuelType = (fuelType: FuelTypes, distanceIn = `km` as DistanceType): string => {
  if (fuelType === `electric`) return `kWh/100${distanceIn}`;
  return `L/100${distanceIn}`;
};

const roundToTwoDecimals = (value: number) => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

export { consumptionByFuelType, kmToSM, MetersToSM, roundToTwoDecimals, SMToKm, SMToMeters };
